import React, { Component } from 'react';
import { Container, Row, Button, Col, } from "reactstrap";
import { observer, inject } from 'mobx-react';
import DataWrapper from '../../principal/containers/DataWrapper';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import desovaPierService from "../../../services/DesovaPierService";
import ModalDesovaPierForm from "../components/ModalDesovaPierForm";
import TabelaDesova from "../components/TabelaDesova";
import Carregamento from "../components/Carregamento";
import Filtros from '../components/Filtros';
import ExportarExcelSolicitacoes from '../components/ExportarExcelSolicitacoes';
import desovaPierController from "../stores/DesovaPierController";
import Footer from '../../comum/components/Footer';
import FooterOptions from '../../comum/components/FooterOptions';

@inject('store')
@DataWrapper
@observer
export default class DesovaPier extends Component {
    constructor(props) {
        super(props)
        this.controller = desovaPierController;
        this.state = {
            carregando: false,
            filtro: {
                operacao: '',
                tipo: 0,
                container: '',
                documento: '',
                bl: '',
                situacao: '',
                dataInicial: '',
                dataFinal: '',
                filterSolicitante: false
            },
            hasFilter: false,
            resultadoPesquisa: [],
            modalType: null,
            id: null
        }

        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.filtrar = this.filtrar.bind(this);
        this.setFiltro = this.setFiltro.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.handleEditClick = this.handleEditClick.bind(this);
        this.handleCancelClick = this.handleCancelClick.bind(this);
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Desova Pier");
    }

    setFiltro(newFiltro) {
        console.log(newFiltro)
        this.setState({ filtro: {...this.state.filtro, ...newFiltro} },()=>{
            let hasFilter = false;
            Object.values(this.state.filtro).forEach(filter => {
                if (!!filter) {
                    hasFilter = true
                    return;
                }
            });
            this.setState({ hasFilter })
        });
    }

    filtrar() {
        this.setState({ carregando: true });
        
        desovaPierService.filtrarSolicitacoes(this.state.filtro)
            .then(result => {
                const resultadoPesquisa = result && result.length > 0 ? result : [];
                this.setState({ resultadoPesquisa })
            })
            .catch((err) => console.log(err))
            .finally(() => this.setState({ carregando: false }));
    }

    closeModal() {
        this.setState({ modalType: null });
        this.controller.clearErrors();
        this.filtrar();
    }

    handleEditClick(id) {
        this.setState({ id, modalType: 'editar' })
    }

    handleVisualizarClick(id){
        this.setState({ id, modalType: 'visualizar' })
    }

    handleCancelClick(id) {
        this.setState({ id, modalType: 'cancelar' })
    }

    handleAttachmentsClick(id) {
        this.setState({ id, modalType: 'anexos' })
    }

    render() {
        return (
            <div className="form-wrapper">
                {this.state.modalType !== null &&
                    <ModalDesovaPierForm
                        controller={this.controller}
                        modalType={this.state.modalType}
                        closeModal={this.closeModal}
                        id={this.state.id}
                        filtrar={this.filtrar}
                    />
                }
                <Carregamento carregando={this.state.carregando} />
                <Container className="tela-botoes-inclusao-topo" fluid>
                    <Row className="botoes-inclusao-topo">
                        <Col xs={12} sm={12} md={12} >
                            <Link to="#">
                                <Button
                                    onClick={() => this.setState({ modalType: 'cadastrar', id: null })}
                                    className="mb-1 btn-com-bordas-primary">
                                    Nova Solicitação
                                </Button>
                            </Link>
                        </Col>
                    </Row>
                    <Filtros 
                        filtrar={this.filtrar} 
                        filtro={this.state.filtro} 
                        setFiltro={this.setFiltro}
                        hasFilter={this.state.hasFilter}
                    />
                    <div style={{ float: 'right', marginTop: '-20px' }}>
                        <Button target="blank" href="https://atendimento.teconline.com.br/hc/pt-br/articles/4414741485197-Desova-Pier" title="Clique aqui para obter ajuda" className="btn-icon-destaque btn-rounded" >
                            <FontAwesomeIcon icon={["fas", "question"]} size={"lg"} />
                        </Button>
                    </div>
                    <TabelaDesova 
                        data={this.state.resultadoPesquisa}
                        filtrar={this.filtrar}
                        editarSolicitacao={(id) => this.handleEditClick(id)}
                        visualizarSolicitacao={(id) => this.handleVisualizarClick(id)}
                        cancelarSolicitacao={(id)=>this.handleCancelClick(id)}
                        anexarDocumentos={(id) => this.handleAttachmentsClick(id)}
                    />
                </Container>
                <Footer>
                    <FooterOptions>
                        <ExportarExcelSolicitacoes 
                            data={this.state.resultadoPesquisa} 
                        />
                    </FooterOptions>
                </Footer>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/modules/desova-pier/telas/DesovaPier.js